// removed by extract-text-webpack-plugin
module.exports = {"body":"_2M2qcy7-jjgr41n_0KldD7","data":"_3zReR9cW44qgcTvgPmthWI","resource":"_2HogFqMpFMx1EKFvDvaGEq","resource-list":"_16Ei2UxZbSD0u0CNyg4wSk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/item/components/body/body.css
// module id = 34
// module chunks = 0